import { Loader } from 'pixi.js';

const loader = new Loader();

export default loader;
